import { create } from 'zustand'

export const useTaskEndpointOptionsStore = create()((set) => ({
    taskEndpointOptions: null,
    setTaskEndpointOptions: (newVal) =>
        set((state) => ({ taskEndpointOptions: newVal })),
}))
